import { Injectable } from "@angular/core";
import { commonService } from "./common.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  private walletSubject = new BehaviorSubject<any>(null);

  wallet$ = this.walletSubject.asObservable();

  constructor(
      private common: commonService
  ) {}


  loadWallet() {

    this.common.get('/wallets/wallet/')
    .subscribe((res:any)=>{

        this.walletSubject.next(res);

    });

  }


  getWallet() {
      return this.walletSubject.value;
  }

}